import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MissionsService } from 'src/app/services/missions.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-modal-additional-questions',
  templateUrl: './modal-additional-questions.page.html',
  styleUrls: ['./modal-additional-questions.page.scss'],
})
export class ModalAdditionalQuestionsPage implements OnInit {
  // @Input() activity: any;
  @Input() listActivities: any;
  answers: {activity_id: number; answers_to_save: { [key: string]: any }; }[] = [];

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.answers = this.listActivities.map(activity => ({
      activity_id: activity.id,
      answers_to_save: {}
    }));  
  }

  updateAnswer(activityId: number, label: string, value: any) {
    const index = this.answers.findIndex(a => a.activity_id === activityId);

    if (index > -1) {
      // Ya existe → actualizar
      this.answers[index].answers_to_save[label] = value;
    } else {
      // No existe → crear
      this.answers.push({
        activity_id: activityId,
        answers_to_save: { [label]: value }
      });
    }
  }

  // This method checks whether all required answers for all activities have been filled.
  // It returns `true` only if each activity's additional questions have all been answered.
  areAllAnswersFilled(): boolean {
    return this.listActivities.every((activity, i) => {
      
      // If the current activity has no additional questions, skip it (treat as complete).
      if (!activity.additional_questions) return true;

      // For activities with additional questions,
      // check that every question has a non-empty answer.
      return activity.additional_questions.every((q) => {
        // Get the value of the answer for the current question label
        const val = this.answers[i].answers_to_save[q.label];

        // Return true only if the value is defined, not null, and not an empty string.
        return val !== undefined && val !== null && val !== '';
      });
    });
  }

  saveAnswersObject() {
    this.modalController.dismiss(this.answers)
  }

  closeModal() {
    this.modalController.dismiss()
  }

}